import { School } from '../school';
export class ClassType {
    constructor(
        public id?: number,
        public name?: string,
        public description?: string,
        public school?: School,
        public active?: boolean,
        public backOfficeUnitPriceId?: string,
        public standardUnitPrice?: number,
        public backgroundColor?: string,
        public acceptOnlinePayments?: boolean,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type.model.ts